export function useTermsOfService() {
  const getTermsContent = () => {
    return (
      <>
        我已阅读并同意
        <span
          className="cursor-pointer"
          style={{ color: '#4086FF' }}
          onClick={(e) => {
            e.preventDefault()
            // eslint-disable-next-line no-restricted-globals
            open('/userAgreement.html', '_blank')
          }}
        >
          《用户协议》
        </span>
        &nbsp;
        <span
          className="cursor-pointer"
          style={{ color: '#4086FF' }}
          onClick={(e) => {
            e.preventDefault()
            // eslint-disable-next-line no-restricted-globals
            open('/privacyPolicy.html', '_blank')
          }}
        >
          《隐私政策》
        </span>
        &nbsp;
        <span
          className="cursor-pointer"
          style={{ color: '#4086FF' }}
          onClick={(e) => {
            e.preventDefault()
            // eslint-disable-next-line no-restricted-globals
            open('/authorizationAgreement.html', '_blank')
          }}
        >
          《授权书》
        </span>
      </>
    )
  }

  return {
    getTermsContent,
  }
}
